export default __webpack_public_path__ + "static/media/arrow_blue.fc9575e5.svg";